import styled from 'styled-components';
import { device } from 'commons';

export const Wrapper = styled.div<{ $checked?: boolean }>`
  width: 100%;
  height: 150px;
  display: flex;
  gap: 12px;
  border: 2px solid ${({ theme }) => theme.neutral_900};
  border-radius: 8px;
  padding: 8px;
  position: relative;

  ${({ $checked, theme }) =>
    $checked &&
    `
    background-color: ${theme.neutral_200};
    border-color: ${theme.neutral_300};
    `}

  @media (min-width: ${device.tablet}px) {
    width: 320px;
  }

  @media (min-width: ${device.desktopSmall}px) {
    width: 400px;
    height: 136px;
  }
`;

export const HiddenCheckbox = styled.input`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
`;

export const Content = styled.div`
  display: flex;
  gap: 12px;
`;

export const ImageWrapper = styled.figure`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100px;
    object-fit: fill;
    object-position: center;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
`;
